export const LOAD_OFFER_QUESTIONS_STARTED = "LOAD_OFFER_QUESTIONS_STARTED";
export const LOAD_OFFER_QUESTIONS_SUCCEEDED = "LOAD_OFFER_QUESTIONS_SUCCEEDED";
export const LOAD_OFFER_QUESTIONS_FAILED = "LOAD_OFFER_QUESTIONS_FAILED";

export const LOAD_OFFER_QUESTIONACTIONS_STARTED = "LOAD_OFFER_QUESTIONACTIONS_STARTED";
export const LOAD_OFFER_QUESTIONACTIONS_SUCCEEDED = "LOAD_OFFER_QUESTIONACTIONS_SUCCEEDED";
export const LOAD_OFFER_QUESTIONACTIONS_FAILED = "LOAD_OFFER_QUESTIONACTIONS_FAILED";
